import { xtwhUrls } from '@shared/urls/xtwhUrls';
import { CacheService } from '@delon/cache';
import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PublicParams } from '@shared/utils/publicParams';
import { ActivatedRoute, Router } from '@angular/router';
import { loginUrls } from '@shared/urls/loginUrls';
import { NormalCode } from '@shared/utils/normalCode';
import { ReuseTabService } from '@delon/abc';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { SettingsService } from '@delon/theme';
import { UserDetailResp } from '@shared/utils/userDetailResp';
import { StartupService } from '@core';
import { NzMessageService, NzModalService } from 'ng-zorro-antd';

interface AppInfo {
  logoName: string;
  copyRight: string;
  schoolName: string;
  ewmName: string;
  version: string;
}

@Component({
  selector: 'layout-passport',
  templateUrl: './passport.component.html',
  styleUrls: ['./passport.component.less'],
})
export class LayoutPassportComponent implements OnInit {
  hasToken = false;
  hasApp = 0;
  logoUrl = '';
  ewmUrl = '';
  version: string;
  copyRight: string;
  isShowEwm = true; // 是否显示二维码

  backImgArr = [
    'url(./../../../assets/images/carousel.jpeg)',
    'url(./../../../assets/images/carousel-two.jpeg)',
    'url(./../../../assets/images/carousel-three.jpeg)',
  ];
  backIdx: number;
  backImg: string;
  links: any;

  carousel: any;

  constructor(
    private cacheSrv: CacheService,
    private http: HttpClient,
    private reuseTabService: ReuseTabService,
    @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
    private settingsService: SettingsService,
    public cacheService: CacheService,
    private router: Router,
    private startupSrv: StartupService,
    public msg: NzMessageService,
    private modal: NzModalService,
    private route: ActivatedRoute,
  ) {
    // this.cacheSrv.get('appInfo').subscribe((appInfo: any) => {
    //   console.log('应用信息', appInfo);
    //   this.carousel = appInfo.carousel.split(',').map((item: any) => {
    //     return item = `url(${xtwhUrls.files.downloadFile_icon}?fileName=${item})`
    //   })
    //   this.backIdx = 0;
    //   this.backImg = this.carousel[this.backIdx];
    //   this.logoUrl = `${xtwhUrls.files.downloadFile_icon}?fileName=${appInfo.logoUrl}`
    //   this.ewmUrl = `${xtwhUrls.files.downloadFile_icon}?fileName=${appInfo.QBCode}`
    // })
  }

  openLink(link: string) {
    // const protocol = window.location.protocol;
    // const url = `${protocol}//${link}`;
    window.open(link);
  }

  querySchoolInfo() {
    this.http.post(xtwhUrls.getSchoolInfo, {}).subscribe((schoolInfo: any) => {
      console.log('学校信息', schoolInfo);
      this.logoUrl = xtwhUrls.files.downloadFile_icon + `?fileName=${schoolInfo.entity.logoimg}`;
      this.ewmUrl = xtwhUrls.files.downloadFile_icon + `?fileName=${schoolInfo.entity.wemimg}`;
      this.version = schoolInfo.entity.version;
      this.copyRight = schoolInfo.entity.copyright;
      this.hasApp = schoolInfo.entity.hasApp;
      this.links = JSON.parse(schoolInfo.entity.links);
      this.carousel = schoolInfo.entity.background.split(',').map((item: any) => {
        return (item = `url(${xtwhUrls.files.downloadFile_icon}?fileName=${item})`);
      });
      this.backIdx = 0;
      this.backImg = this.carousel[this.backIdx];
    });
  }

  autoPlay() {
    ++this.backIdx;
    if (this.backIdx >= this.carousel.length) {
      this.backIdx = 0;
    }
    this.backImg = this.carousel[this.backIdx];
  }

  /**
   * cas登录功能
   * @param token 第三方token
   */
  casSuccess(token: string) {
    console.log('token is ', token);
    // 清空路由复用信息
    this.reuseTabService.clear();
    // 设置用户Token信息
    this.tokenService.set({ token });
    // 登录成功后，设置token，获取用户信息
    this.http.post(loginUrls.queryUserInfo.url, {}).subscribe(
      (response: any) => {
        console.log(response);
        if (response.err_code === NormalCode.NORMAL_CODE) {
          // set侧边栏顶部用户信息
          this.settingsService.setUser({
            avatar: response.avatarId,
            name: response.name,
            email: response.email,
          });
          // 缓存当前登录用户信息
          sessionStorage.setItem(PublicParams.cacheUserName, JSON.stringify(new UserDetailResp(response)));
          this.cacheService.set(PublicParams.cacheUserName, new UserDetailResp(response));
          this.startupSrv.load().then(() => {
            if (response.role.includes('学生')) {
              this.router.navigateByUrl('/student');
            } else {
              // 路由跳转
              this.router.navigateByUrl('/teacher');
            }
            // this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
            //   if (!res.email || !res.phone) {
            //     this.modal.confirm({
            //       nzTitle: '<i>提示?</i>',
            //       nzContent:
            //         '<b>系统检测到你当前账号未绑定手机，为了你的账号安全起见，请先进行手机绑定，否则将无法使用其相关功能，是否立即前往绑定？</b>',
            //       nzOnOk: () => this.router.navigateByUrl('/account-settings'),
            //     });
            //   }
            // });
          });
        } else {
          this.msg.error(response.err_msg);
          this.hasToken = false;
          this.router.navigateByUrl('/login');
        }
      },
      err => {
        this.hasToken = false;
        this.router.navigateByUrl('/login');
      },
    );
  }

  toDownload() {
    const { protocol, host } = window.location;
    const url = `${protocol}//${host}/#/download`;
    window.open(url);
  }

  ngOnInit() {
    const token = this.route.snapshot.queryParams.token;
    if (token != null) {
      // 先清空缓存
      sessionStorage.clear();
      this.tokenService.clear();
      this.cacheService.clear();

      this.hasToken = true;
      sessionStorage.setItem(PublicParams.thirdParam, PublicParams.thirdValue);
      sessionStorage.setItem('token', token);
      this.casSuccess(token);
    } else {
      this.querySchoolInfo();
      setInterval(() => {
        this.autoPlay();
      }, 5000);
    }
  }
}
